import * as asset from './Endpoints/AssetEndpoint';
import * as bulkUpload from './Endpoints/BulkUploadEndpoint';
import * as device from './Endpoints/DeviceEndpoint';
import * as orders from './Endpoints/OrderEndpoint';
import * as qualityRecords from './Endpoints/QualityRecords';
import * as sato from './Endpoints/SatoEndpoint';
import search from './Endpoints/SearchEndpoint';
import * as set from './Endpoints/SetEndpoint';
import * as user from './Endpoints/UserEndpoint';
import * as userManagement from './Endpoints/UserManagementEndpoint';
import * as UssEndpoint from './Endpoints/UssEndpoint';
import errorHandler from './ErrorHandler';

export type LanguageMetadata = {
  manual_japanese?: string | null;
  manual_english?: string | null;
  description_japanese?: string | null;
  description_english?: string | null;
};

export type TestMetadata = {
  additional_inspection_english?: string | null;
  additional_inspection_japanese?: string | null;
  torque_test?: boolean;
  functional_test?: boolean;
  debris_test?: boolean;
};

const API = {
  set,
  device,
  search,
  asset,
  sato,
  qualityRecords,
  errorHandler,
  user,
  userManagement,
  orders,
  bulkUpload,
  UssEndpoint,
};

export default API;
